export const labels = {
  navGallery: { fr: 'Galerie Photos', en: 'Photo Gallery' },
  navBio: { fr: 'Biographie & Coordonnées', en: 'Biography & Contact' },
  close: { fr: 'Fermer', en: 'Close' },
  next: { fr: 'Suivant', en: 'Next' },
  prev: { fr: 'Precedent', en: 'Previous' },
};

export function tWithFallback(obj, lang) {
  if (!obj || typeof obj !== 'object') return '';
  const value = obj[lang];
  if (Array.isArray(value)) {
    return value.length ? value : obj.fr || [];
  }
  if (typeof value === 'string') {
    return value.trim() ? value : obj.fr || '';
  }
  if (value !== undefined && value !== null) return value;
  return obj.fr || '';
}
